import { useTheme as useMuiTheme } from "@mui/material/styles";

export const useTheme = useMuiTheme;
